import { InjectionToken } from '@angular/core';
import { AnalyticsChartsGateway } from './analytics-charts-gateway.interface';

export const ANALYTICS_CHARTS_GATEWAY =
  new InjectionToken<AnalyticsChartsGateway>('analytics-charts-gateway');
